
import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { onError } from "../libs/errorLib";
import { makeStyles, withStyles, styled } from '@material-ui/core/styles';


import { API } from "aws-amplify";

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';

import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';




import RunIcon from '@material-ui/icons/PlayCircleFilled';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import AddIcon from '@material-ui/icons/AddCircleOutlineRounded';
import CancelIcon from '@material-ui/icons/Cancel';
import ArtifactingIcon from '@material-ui/icons/FormatListNumbered';
import ExtractionIcon from '@material-ui/icons/Grain';
import FlareIcon from '@material-ui/icons/Flare';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import SyncIcon from '@material-ui/icons/Sync';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';


import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';




import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import Button from '@material-ui/core/Button';
//import Button from "../components/LoaderButtonX";
import Link from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';

import ButtonBase from '@material-ui/core/ButtonBase';


import Fab from '@material-ui/core/Fab';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Chip from '@material-ui/core/Chip';
//import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';

//import Box from '@material-ui/core/Box';
//import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

//import LocationOnRoundedIcon from '@material-ui/icons/LocationOnRounded';
//import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
//import Brightness3Icon from '@material-ui/icons/Brightness3';
//import InvertColorsIcon from '@material-ui/icons/InvertColors';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';


import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';


import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

import Container from '@material-ui/core/Container';


import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';

import { HighlightWithinTextarea } from 'react-highlight-within-textarea';
import "../containers/Prompt.css";




export default function TabMetadata(props) {
    const { project, docRef, updateConfig, config, updateSteps, disabled } = props;
    console.log(config.options.topP);
    const [promptUser, setPromptUser] = useState(config && config.options && config.options.promptUser ? config.options.promptUser : "");
    const [promptSys, setPromptSys] = useState(config && config.options && config.options.promptSys ? config.options.promptSys : "");
    const [temperature, setTemperature] = useState(config?.options?.temperature !== undefined ? config.options.temperature : 0.0);
    const [topP, setTopP] = useState(config?.options?.topP !== undefined ? config.options.topP : 1.0);
    const [presencePenalty, setPresencePenalty] = useState(config?.options?.presencePenalty !== undefined ? config.options.presencePenalty : 0.0);
    const [frequencyPenalty, setFrequencyPenalty] = useState(config?.options?.frequencyPenalty !== undefined ? config.options.frequencyPenalty : 0.0);
    const [selectedModel, setSelectedModel] = useState(config && config.options && config.options.model ? config.options.model : "gpt-4.1-mini");
    const [artPageNo, setArtPageNo] = useState(config && config.options && config.options.chunkSize ? config.options.chunkSize : 4);
    const [isUploading, setIsUploading] = useState("");
    const [jobId, setJobId] = useState(null);
    const [copied, setCopied] = useState(false);
    const [resultsData, setResultsData] = useState("");
    const [isRunning, setIsRunning] = useState(false);
    const [resOpen, setResOpen] = useState(false);

    const [resultsTitle, setResultsTitle] = useState('');
    const [resultsStatus, setResultsStatus] = useState('');

    const resultsStatusRef = useRef(resultsStatus);
    const startTimeRef = useRef(0);


    const models = [
        { value: 'gpt-4.1-mini', label: 'GPT-4.1 Mini' },
        { value: 'gpt-4.1', label: 'GPT-4.1' },
        { value: 'gpt-4o', label: 'gpt-4o' },
        { value: 'gpt-3.5-turbo', label: 'GPT-3.5 Turbo' }
    ];

    const ExpandMore = styled((props) => {
        const { expand, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand }) => ({
        transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));

    const run = async (e) => {
        e.preventDefault();
        resetResults();
        saveConfig();
        startTimeRef.current = Date.now();
        setIsRunning(true);
        updateSteps(0, false);
        setResOpen(true);
        runMetadataExtractor();
    }
    const clearResults = async (e) => {
        e.preventDefault();
        resetResults();
    }

    function resetResults() {
        setResultsTitle('');
        setResultsData("");
        setResOpen(false);
    }


    const saveConfig = async () => {
        const body = { type: "meta", values: { options: { promptSys: promptSys, promptUser: promptUser, chunkSize: artPageNo, model: selectedModel, temperature: temperature, topP: topP, presencePenalty: presencePenalty, frequencyPenalty: frequencyPenalty } } };
        await updateConfig(body);
    }

    const copyToClipboard = (e) => {
        navigator.clipboard.writeText(resultsData)
            .then(() => {
                console.log("Text copied to clipboard!");
                setCopied(true);
                setTimeout(() => setCopied(false), 1500); // hide after 2 sec
            })
            .catch(err => {
                console.error("Failed to copy: ", err);
            });
    }


    useEffect(() => {
        let pollingInterval;
        if (isRunning) {
            pollingInterval = setInterval(updateResultsStatus, 300); // Check every 5 seconds
        }
        try {
            return () => {
                clearInterval(pollingInterval);
            } // Clear polling on unmount or when parsing stops
        } catch (e) {
            // do nowt
        }
    }, [isRunning]); //

    const updateResultsStatus = () => {
        const timeDiff = (Date.now() - startTimeRef.current) / 1000;
        setResultsStatus(timeDiff)

    }
      function getOpenAI(body) {
        return API.post("findigai", "/openai", {
          body: body
        });
      }


    /////// Step Specific Stuff /////////////////////////////////

    const handleArtPageNoChange = async (e) => {
        e.preventDefault();
        let newValue = Number(e.target.value);
        if (newValue > 100) newValue = 10;
        if (newValue < 1) newValue = 1;
        setArtPageNo(newValue);
    }
    const handleTopPChange = async (e) => {
        e.preventDefault();
        let newValue = Number(e.target.value);
        if (newValue >= 1) newValue = 1.0;
        if (newValue < 1) newValue = 0.0;
        setTopP(newValue);
    }
    const handleTemperatureChange = async (e) => {
        e.preventDefault();
        let newValue = Number(e.target.value);
        if (newValue >= 1) newValue = 1.0;
        if (newValue < 1) newValue = 0.0;
        setTemperature(newValue);
    }
    const handlePresencePenaltyChange = async (e) => {
        e.preventDefault();
        let newValue = Number(e.target.value);
        if (newValue >= 1) newValue = 1.0;
        if (newValue < 1) newValue = 0.0;
        setPresencePenalty(newValue);
    }
    const handleFrequencyPenaltyChange = async (e) => {
        e.preventDefault();
        let newValue = Number(e.target.value);
        if (newValue >= 1) newValue = 1.0;
        if (newValue < 1) newValue = 0.0;
        setFrequencyPenalty(newValue);
    }

    async function runMetadataExtractor() {

        //let chunkSize = artPageNo; //ie the number of pages from the top of the doc to use for metadata extraction
        //let status = 2;
        let resultsStr = "";
        const attempts = 4;
        //const params = { type: 'metadataQuery', prjid: project.itemId, docid: docid, keyId: input.openAiKeyId, pages: input.pages };


        try {
            const result = await getOpenAI({ type: "metadataQuery", prjid: project.itemId, docid: docRef.current.itemId, keyId: 1 });
            console.log(result);
            resultsStr = result.data;
            setIsRunning(false);
            updateSteps(1, true);
        } catch (err) {
            setIsRunning(false);
            console.error("OpenAI Error:", err?.response?.data || err.message || err);
            resultsStr = "OpenAI Error: " + err?.response?.data || err.message || err;
        }
        setResultsData(resultsStr);

    }




    /*
        async function runParser() {
            console.log(doc);
            setIsRunning(true);
            updateSteps(0, false);
            setResOpen(true);
            parseDoc({ type: "bufferParse", doc: doc }) // project id is doc pk
                .then(resultParse => {
                    console.log("Got data:", resultParse);
                    const data = typeof resultParse.data === "string" ? JSON.parse(resultParse.data) : resultParse.data;
                    //setDocId(resultParse.docId);
                    const { id, status } = data;
                    console.log(data);
                    //setResultsData(status);
                    //setParsingStatus(status);
                    setJobId(id);
                }).catch(err => {
                    setIsRunning(false);
                    console.log('err');
                    console.error('Error uploading file:', err);
                });
        }
    
        function parseDoc(body) {
            console.log(body);
            return API.post("findigai", "/parse", {
                body: body
            });
        }
    
    
        useEffect(() => {
            //console.log("polling");
            let pollingInterval;
            if (isRunning) {
                pollingInterval = setInterval(pollParsingStatus, 5000); // Check every 5 seconds
            }
            try {
                return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
            } catch (e) {
                // do nowt
            }
    
        }, [isRunning, jobId]);
    
    
        const pollParsingStatus = async () => {
            if (isRunning) {
                try {
                    if (!jobId) return;
                    const resultJob = await parseDoc({ type: "job", id: jobId, doc: doc });
                    const { status } = resultJob.data;
                    if (status !== "PENDING") { //PENDING, SUCCESS, ERROR, PARTIAL_SUCCESS, CANCELLED
                        if (status === "SUCCESS") {
                            updateSteps(0, true);
                        } else {
                            updateSteps(-1, false);
                            console.log("DOC PARSING FAILED: ", status)
                        };
                        setIsRunning(false);
                    }
                } catch (error) {
                    updateSteps(-1, false);
                    setIsRunning(false);
                    console.error('Error checking parsing status:', error);
                }
            }
        };
    */


    return (
        <>
            {/* RESULTS SECTION */}

            <Box mt={1}>
                <Paper style={{ backgroundColor: "#e8f6f3" }}>
                    <Box p={1} >
                        <Box display="flex" alignItems='center' flexDirection="row" >
                            <Box mx={1} pb={1}>
                                <Tooltip title="Run">
                                    <IconButton
                                        onClick={run}
                                        disabled={isRunning || docRef.current.itemStatus<1 || disabled}
                                        size="small"
                                    >
                                        <RunIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Box mx={1} pb={1}>
                                <Tooltip title="Clear results">
                                    <IconButton
                                        onClick={clearResults}
                                        disabled={docRef.current.itemStatus<1 || disabled}
                                        size="small"
                                    >
                                        <CancelIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Box pv={0} >
                                <Typography variant="body2" style={{ color: 'green', fontSize: '0.8rem' }}>
                                    &nbsp;&nbsp;&nbsp;{Number(resultsStatus).toFixed(2) + " seconds"}
                                </Typography>
                            </Box>
                            <Box sx={{ flexGrow: 1 }} ></Box>
                            <Box mx={1} pb={1}>
                                <Tooltip title="Copy results to clipboard">
                                    <IconButton
                                        onClick={copyToClipboard}
                                        disabled={disabled}
                                        size="small"
                                    >
                                        <FileCopyIcon />
                                    </IconButton>
                                </Tooltip>
                                {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                            </Box>
                            <ExpandMore
                                color="primary"
                                expand={resOpen}
                                onClick={() => { setResOpen(!resOpen) }}
                                aria-expanded={resOpen}
                                aria-label="show results"
                                size="small"
                                id="resOpen">
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Box>
                        <Collapse in={resOpen} timeout="auto" unmountOnExit>
                            <>
                                <h6><u>{resultsTitle}</u></h6>
                                <Box m={2}>
                                    <Paper>
                                        <Box m={1} py={1}>
                                            <div style={{ whiteSpace: 'pre-wrap' }}>{resultsData}</div>
                                        </Box>
                                    </Paper>
                                </Box>
                            </>
                        </Collapse>
                    </Box>

                </Paper>
            </Box>

            {/* OPTIONS SECTION */}

            <Box mt={1}>
                <Paper style={{ backgroundColor: "#f2f2ff" }}>
                    <Box p={2}>


                        <Box pv={2} pl={0.5}>
                            <h6>System prompt</h6>
                        </Box>

                                                  <Paper style={{ backgroundColor: "#fff" }}>
                                                    <Box p={1}>
                                                      <HighlightWithinTextarea
                                                        disabled={isRunning}
                                                        placeholder="<empty>"
                                                        value={promptSys ?? ""}
                                                        highlight={[
                                                          { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                                          { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                                          { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                                        ]}
                                                        onChange={(text) => setPromptSys(text)}
                                                      />
                                                    </Box>
                                                  </Paper>
                                                  {/*}
                        <TextareaAutosize
                            disabled={isRunning || disabled}
                            minRows={1}
                            placeholder="<empty>"
                            value={promptSys}
                            onChange={(e) => setPromptSys(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '12px',
                                fontSize: '16px',
                                borderRadius: '8px',
                                border: '1px solid #ccc',
                                resize: 'vertical',
                            }}
                        />*/}
                        <Box pt={3} pb={0} pl={0.5} >
                            <h6>User prompt</h6>
                        </Box>
                          <Paper style={{ backgroundColor: "#fff" }}>
                            <Box p={1}>
                              <HighlightWithinTextarea
                                disabled={isRunning}
                                placeholder="<empty>"
                                value={promptUser ?? ""}
                                highlight={[
                                  { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                  { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                  { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                ]}
                                onChange={(text) => setPromptUser(text)}
                              />
                            </Box>
                          </Paper>
                          {/*}
                        <TextareaAutosize
                            disabled={isRunning || disabled}
                            minRows={1}
                            placeholder="<empty>"
                            value={promptUser}
                            onChange={(e) => setPromptUser(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '12px',
                                fontSize: '16px',
                                borderRadius: '8px',
                                border: '1px solid #ccc',
                                resize: 'vertical',
                            }}
                        />*/}

                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                            <Box width={26} pt={3} pb={0} pl={0.5} >
                                <Paper>
                                    <TextField
                                        type="number"
                                        disabled={isRunning || disabled}
                                        value={artPageNo}
                                        onChange={handleArtPageNoChange}
                                        disableUnderline
                                        inputProps={{
                                            disableUnderline: true,
                                            min: 1,
                                            max: 10,
                                        }}
                                    />
                                </Paper>
                            </Box>
                            <Box pt={3} pb={0} pl={0.5} >
                                <h6> use top n pages</h6>
                            </Box>
                        </Box>

                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                            <Box width={26} pt={3} pb={0} pl={0.5} >
                                <Paper>
                                    <TextField
                                        type="number"
                                        disabled={isRunning || disabled}
                                        value={temperature}
                                        onChange={handleTemperatureChange}
                                        disableUnderline
                                        inputProps={{
                                            disableUnderline: true,
                                            min: 0,
                                            max: 1,
                                        }}
                                    />
                                </Paper>
                            </Box>
                            <Box pt={3} pb={0} pl={0.5} >
                                <h6> Temperature</h6>
                            </Box>
                        </Box>

                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                            <Box width={26} pt={3} pb={0} pl={0.5} >
                                <Paper>
                                    <TextField
                                        type="number"
                                        disabled={isRunning || disabled}
                                        value={topP}
                                        onChange={handleTopPChange}
                                        disableUnderline
                                        inputProps={{
                                            disableUnderline: true,
                                            min: 0,
                                            max: 1,
                                        }}
                                    />
                                </Paper>
                            </Box>
                            <Box pt={3} pb={0} pl={0.5} >
                                <h6> Top P</h6>
                            </Box>
                        </Box>

                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                            <Box width={26} pt={3} pb={0} pl={0.5} >
                                <Paper>
                                    <TextField
                                        type="number"
                                        disabled={isRunning || disabled}
                                        value={presencePenalty}
                                        onChange={handlePresencePenaltyChange}
                                        disableUnderline
                                        inputProps={{
                                            disableUnderline: true,
                                            min: 0,
                                            max: 1,
                                        }}
                                    />
                                </Paper>
                            </Box>
                            <Box pt={3} pb={0} pl={0.5} >
                                <h6> Presence penalty</h6>
                            </Box>
                        </Box>
                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                            <Box width={26} pt={3} pb={0} pl={0.5} >
                                <Paper>
                                    <TextField
                                        type="number"
                                        disabled={isRunning || disabled}
                                        value={frequencyPenalty}
                                        onChange={handleFrequencyPenaltyChange}
                                        disableUnderline
                                        inputProps={{
                                            disableUnderline: true,
                                            min: 0,
                                            max: 1,
                                        }}
                                    />
                                </Paper>
                            </Box>
                            <Box pt={3} pb={0} pl={0.5} >
                                <h6> Frequency penalty</h6>
                            </Box>
                        </Box>

                        <Box my={2} ml={0.5}>
                            <select
                                id="model"
                                disabled={isRunning || disabled}
                                value={selectedModel}
                                onChange={(e) => setSelectedModel(e.target.value)}
                            >
                                {models.map((model) => (
                                    <option key={model.value} value={model.value}>
                                        {model.label}
                                    </option>
                                ))}
                            </select>

                        </Box>



                    </Box>
                </Paper>
            </Box>





        </>
    )
};